function isTouchEnabled() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export class ResizeHandles {
  private selectionLayer;
  private svg;
  private options;
  body;
  bl;
  br;
  tl;
  tr;
  group;

  constructor(svg, selectionLayer, options) {
    this.selectionLayer = selectionLayer;
    this.svg = svg;
    this.options = options;
    this.createHandles();
  }

  public getResizeControls() {
    return {
      body: this.body,
      bl: this.bl,
      br: this.br,
      tl: this.tl,
      tr: this.tr
    };
  }

  createHandles = function () {
    this.group = this.selectionLayer.append('g');

    const touchEnabled = isTouchEnabled();

    this.tl = this.group
      .append('circle')
      .attr('r', touchEnabled ? '7' : '7')
      .attr('stroke', 'white')
      .style('stroke-width', 2)
      .attr('fill', '#3C9ED4')
      .attr('id', 'cTopLeft')
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('display', 'none')
      .style('cursor', 'nw-resize')
      .classed('shadow-svg', true);

    this.tr = this.group
      .append('circle')
      .attr('r', touchEnabled ? '7' : '7')
      .attr('stroke', 'white')
      .style('stroke-width', 2)
      .attr('fill', '#3C9ED4')
      .attr('id', 'cTopRight')
      .attr('cy', 0)
      .attr('display', 'none')
      .style('cursor', 'ne-resize')
      .classed('shadow-svg', true);

    this.br = this.group
      .append('circle')
      .attr('r', touchEnabled ? '7' : '7')
      .attr('stroke', 'white')
      .style('stroke-width', 2)
      .attr('fill', '#3C9ED4')
      .attr('id', 'cBottomRight')
      .attr('display', 'none')
      .style('cursor', 'se-resize')
      .classed('shadow-svg', true);

    this.bl = this.group
      .append('circle')
      .attr('r', touchEnabled ? '7' : '7')
      .attr('stroke', 'white')
      .style('stroke-width', 2)
      .attr('fill', '#3c9ed4')
      .attr('id', 'cBottomLeft')
      .attr('cx', 0)
      .style('cursor', 'sw-resize')
      .attr('display', 'none')
      .classed('shadow-svg', true);

    this.body = this.group
      .append('rect')
      .attr('id', 'getBBoxRect')
      .attr('stroke', '#5A5A5A')
      .attr('stroke-dasharray', '5,5')
      .attr('stroke-width', 1)
      .style('stroke-opacity', 1)
      .attr('x', 0)
      .attr('y', 0)
      .attr('fill', '#fff')
      .style('fill-opacity', 0.3)
      .style('pointer-events', 'all')
      .style('cursor', 'all-scroll');
  };

  clearResizeHandles = function () {
    this.body.attr('display', 'none');
    this.tl.attr('display', 'none');
    this.tr.attr('display', 'none');
    this.bl.attr('display', 'none');
    this.br.attr('display', 'none');
  };

  drawResizeHandles = function (wrapper, item, mainContainer, options) {
    const { zoomStep = 0 } = options;
    let drawHandlers = false;
    const zoom = (10 + zoomStep) / 10;
    const mc = this.svg.node().getBoundingClientRect();
    const { x, y } = wrapper.getBoundingClientRect();
    const { width, height } = wrapper.getBBox();
    const { imgWidth: mainWidth, imgHeight: mainHeight } = this.options;
    const zoomX = mainWidth / mc.width;
    const zoomY = mainHeight / mc.height;
    this.clearResizeHandles();
    if (item.type === 'rectangle' || item.type === 'ellipse' || item.type === 'circle' || item.type === 'svgElement') {
      drawHandlers = true;
    }
    this.group.attr('transform', `translate(${(x - mc.left) * zoomY},${(y - mc.top) * zoomY})`);
    this.body.attr('display', 'inline');
    this.body.attr('width', width).attr('height', height);

    this.tl.attr('display', drawHandlers ? 'inline' : 'none');
    this.tr.attr('cx', width).attr('display', drawHandlers ? 'inline' : 'none');

    this.br
      .attr('cx', width)
      .attr('cy', height)
      .attr('display', drawHandlers ? 'inline' : 'none');

    this.bl.attr('cy', height).attr('display', drawHandlers ? 'inline' : 'none');
  };
}
